import { Badge } from "../ui/badge";
import { CRM_STATUS_LABELS, CRM_STATUS_VARIANT } from "../../lib/crm";
import type { CrmAccountStatus } from "@shared/types";

export function CrmStatusBadge({ status }: { status: CrmAccountStatus }) {
  return <Badge variant={CRM_STATUS_VARIANT[status]}>{CRM_STATUS_LABELS[status]}</Badge>;
}
